<template>
  <div class="result-chart" id="result-chart"> </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'cna-radar',

  components: {},

  props: {
    info: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      average: [60, 100, 85, 87, 92, 80],
      your: [75, 81, 96, 80, 75, 96]
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.initChart()
  },

  destroyed() {},

  methods: {
    initChart() {
      let coreArr = this.info.radarResult.returnScoreArr
      let your = coreArr.map((item) => {
        return item.score
      })
      let average = coreArr.map((item) => {
        return item.averageScore
      })
      option = {
        legend: {
          left: '6%',
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: 'rgba(0,0,0,0.5)'
          },
          align: 'left',
          data: [
            {
              itemStyle: {
                opacity: 1
              },
              icon: 'image://https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f9e5a08b0ac5263e48c1498fcf15ab3c.png',
              name: '你的得分'
            },
            {
              itemStyle: {
                opacity: 1
              },
              icon: 'image://https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f8b23e4f5f3517caf21cc23eec93a157.png',
              name: '同龄人平均得分'
            }
          ]
          //show: false
        },
        grid: {
          containLabel: true
        },
        radar: {
          shape: 'circle',
          radius: '60%',
          bottom: '5.6%',
          startAngle: 120,
          indicator: (function () {
            var res = []
            // var indicatorList = ['运动', '睡眠', '习惯', '情绪', '体质', '饮食']
            coreArr.map((item) => {
              res.push({ text: `${item.name} ${item.score}`, max: 100 })
            })
            return res
          })(),
          splitArea: {
            show: false
          },
          axisName: {
            color: '#363D54',
            fontSize: '12px',
            fontWeight: '600'
          }
        },
        series: [
          {
            type: 'radar',
            symbol: 'none',
            lineStyle: {
              width: 3
            },
            data: [
              {
                value: average,
                name: '同龄人平均得分',
                lineStyle: {
                  opacity: 0
                },
                itemStyle: {
                  opacity: 0
                },
                emphasis: {
                  disabled: true
                },
                areaStyle: {
                  color: 'rgba(255,199,239,1)',
                  opacity: 1
                }
              },
              {
                value: your,
                name: '你的得分',
                lineStyle: {
                  opacity: 0
                },
                itemStyle: {
                  opacity: 0
                },
                emphasis: {
                  disabled: true
                },
                areaStyle: {
                  color: 'rgb(81, 115, 255)',
                  opacity: 0.5
                }
              }
            ]
          }
        ]
      }

      var chartDom = document.getElementById('result-chart')
      var myChart = echarts.init(chartDom, null, { renderer: 'svg' })
      var option
      option && myChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.result-chart {
  height: 251px;
}
</style>
